import {
  Component,
  ComponentFactoryResolver,
  HostBinding,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import {
  ExplorerService,
  ModalConfig,
} from "app/modules/shared/services/explorer.service";
import { KlDyModalComponent } from "app/modules/dashboard/components/partials/modal/modal.component";

@Component({
  selector: "kl-modal",
  template: ` <ng-template #modalHolder></ng-template> `,
})
export class KlModalComponent {
  modals = [];
  @ViewChild("modalHolder", { read: ViewContainerRef, static: true })
  modalHolder: ViewContainerRef;
  @HostBinding("class.has-modal") hasModal = false;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private explorer: ExplorerService
  ) {
    // catch the modal which will open
    explorer.modalStream$.subscribe((modalConfig) => {
      this.openModal(modalConfig);
      this.checkBackgroundState();
    });
    // catch the modal which will close
    explorer.modalCloseStream$.subscribe((modalConfig) => {
      this.closeModal(modalConfig);
      this.checkBackgroundState();
    });
  }

  openModal(modalConfig: ModalConfig) {
    const viewContainerRef = this.modalHolder;
    const componentFactory =
      this.componentFactoryResolver.resolveComponentFactory(KlDyModalComponent);
    const instance = viewContainerRef.createComponent(componentFactory)
      .instance as KlDyModalComponent;
    instance.title = modalConfig.title;
    instance.active = true;
    instance.stateSelector = modalConfig.stateSelector;
    instance.childTemplate = modalConfig.childTemplate;
    this.modals.push(instance);
    this.setActive(instance);
  }

  closeModal(modal) {
    const length = this.modals.length;
    for (let index = 0; index < length; index++) {
      const m = this.modals[index];
      if (modal.hasOwnProperty("childInstance")) {
        if (m === modal) {
          this.modals.splice(index, 1);
          const viewContainerRef = this.modalHolder;
          viewContainerRef.remove(index);
        }
      } else {
        if (m.childInstance === modal) {
          this.modals.splice(index, 1);
          const viewContainerRef = this.modalHolder;
          viewContainerRef.remove(index);
        }
      }
    }
    const lastModal = this.modals.slice(-1).pop();
    if (lastModal) {
      this.setActive(lastModal);
    }
  }

  setActive(_modal: KlDyModalComponent) {
    this.modals.forEach((modal) => (modal.active = false));
    _modal.active = true;
  }

  checkBackgroundState(): boolean {
    return (this.hasModal = this.modals.length > 0);
  }
}
